import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import FormRecuperarPassword from './components/Main/FormRecoverPassword';
import './index.scss';
import { BrowserView, MobileView } from 'react-device-detect';

class NewPassword extends Component {
  render() {
    return (
      <div className="sign-container">
        <BrowserView>
          <div >
            <Header />
            <div className="container-general container-background">

              <FormRecuperarPassword />

            </div>
          </div>
        </BrowserView>
        <MobileView>
          <div className="sign-in_center">
            <FormRecuperarPassword />
          </div>
        </MobileView>
      </div>
    );
  }
}

export default NewPassword;
